import { ds } from "js/core/models/dataService";

/**
 * Opens Dropbox file selection UI.
 */
function chooseFile(extensions, multiple = false) {
    return new Promise((resolve, reject) => {
        window.Dropbox.choose({
            success: files => {
                const selectedFiles = files.map(file => ({
                    id: file.id,
                    name: file.name,
                    url: file.link,
                    size: file.bytes,
                    success: true,
                    source: "dropbox"
                }));
                resolve(multiple ? selectedFiles : selectedFiles[0]);
            },
            cancel: () => {
                resolve({ cancelled: true });
            },
            linkType: "direct",
            multiselect: multiple,
            extensions,
            folderselect: false,
            sizeLimit: 32 * 1024 * 1024
        });
    });
}

/**
 * Opens dropbox file selection UI and fetches the file. Currently only allows selection of one file at a time.
 */
async function chooseAndGetFile(extensions) {
    const dropboxResp = await chooseFile(extensions);
    if (dropboxResp.cancelled) {
        return { cancelled: true };
    }
    const fetchResp = await fetch(dropboxResp.url);
    const data = await fetchResp.blob();

    return new File([data], dropboxResp.name, {
        type: data.type
    });
}

/**
 * Saves a Google Cloud Storage asset to a user's selected Dropbox destination.
 */
function saveFileFromUrl(url, fileName) {
    return new Promise((resolve, reject) => {
        window.Dropbox.save({
            // Replacing "/" in filename so Dropbox don't threat them as folder splitters
            files: [{ url, filename: fileName.replace(/\//g, " ") }],
            success: () => {
                resolve({ success: true });
            },
            progress: () => { },
            cancel: () => {
                resolve({ cancelled: true });
            },
            error: errorMessage => {
                reject(new Error(errorMessage));
            }
        });
    });
}

/**
 * Saves a blob asset to a user's selected Dropbox destination
 */
async function saveFileFromBlob(blob, fileName, contentType) {
    const { readUrl } = await ds.assets.uploadTempAssetFile(blob, contentType);
    return saveFileFromUrl(readUrl, fileName);
}

module.exports = { chooseFile, chooseAndGetFile, saveFileFromUrl, saveFileFromBlob };
export default { chooseFile, chooseAndGetFile, saveFileFromUrl, saveFileFromBlob };
